export const environment = {
  version: "1.17.0",
  production: true,
  apiBase: "https://terrymapper-api.terryx.ch/",
  appBase: "https://terrymapper-dev-frontend.terryx.ch/",
  apiDrone: "https://pg.terryx.ch",
  defaultLanguage: "en",
  cesiumAccessToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmZmNlMzhmMi05YzlmLTQ4YjctYWE2Ny0wNjA4ODU4NmM0YmYiLCJpZCI6NDQxMzAsImlhdCI6MTYxMzY0MjUyM30.Bjjf3ejMxxryOEM-lJm3K7bUgccCXuGU7KxkyKlAWMk",
  terryxApiBase: "https://api.terra3d.ch/",
};
